import { Table } from "react-bootstrap";
import swal from "sweetalert";
import {CgCopy} from "react-icons/cg";


export default function EventBookingDetails(props){

    const reqData = props.data;
    const userData = props.userData;
    const celebData = props.celebData;

    return (
        <div className="bg-white/20 h-full w-full flex justify-center items-center">

            <Table bordered className="text-white table-fixed">
                <tbody>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                User
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {userData["fullName"]}
                            </div>
                        </td>
                        <td className="w-full flex justify-center items-center">
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(props.userId).then(function () {
                                        console.log('Async: Copying to clipboard was successful!');
                                    }, function (err) {
                                        console.error('Async: Could not copy text: ', err);
                                    });
                                    swal("Copied", "User ID was copied to the clipboard", "success");
                                }}
                                className="hover:scale-105 flex justify-center items-center">
                                <CgCopy size={40} color={"black"} className="bg-white p-2 rounded" />
                            </button>
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Celebrity
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {celebData["fullName"]}
                            </div>
                        </td>
                        <td className="w-full">
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(props.celebId).then(function () {
                                        console.log('Async: Copying to clipboard was successful!');
                                    }, function (err) {
                                        console.error('Async: Could not copy text: ', err);
                                    });
                                    swal("Copied", "Celeb ID was copied to the clipboard", "success");
                                }}
                                className="w-full hover:scale-105 flex justify-center items-center">
                                <CgCopy size={40} color={"black"} className="bg-white p-2 rounded" />
                            </button>
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Amount
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["amount"]}₵
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Discount
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["discount"]}₵
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Type
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["type"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Event Description
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["eventDescription"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>



                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Venue Name
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["venueName"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Location
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                            
                                <a href={`https://maps.google.com/maps?q=${reqData["loc_x"].toString()},${reqData["loc_y"].toString()}&hl=es;z=14&amp;output=embed`}>
                                    <div>
                                        {`https://maps.google.com/maps?q=${reqData["loc_x"].toString()},${reqData["loc_y"].toString()}&hl=es;z=14&amp;output=embed`}
                                    </div>
                                </a>
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>




                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Venue Name
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["virtualEvent"]==true?"Yes":"No"}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Public Event
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["publicEvent"]==true?"Yes":"No"}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Organization
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["organization"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    
                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Booking Email
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["email"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Booking Phone
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["countryCode"]}{reqData["phoneNumber"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Appearance Time
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["appearanceHours"]} Hour {reqData["appearanceMinutes"]} Minutes
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Event Date
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["date"].toDate().getDate().toString()}-{(reqData["date"].toDate().getMonth() + 1).toString()}-{reqData["date"].toDate().getFullYear().toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Starting Time
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["timeStart"]} {reqData["startFormat"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Starting Time
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["timeEnd"]} {reqData["endFormat"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>






                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Reason for appearance
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["reasonForAppearance"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Booking Type
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["bookingTypes"].toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Booking Type
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["bookingReasons"].toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Any Other Engagements
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["anyOtherEngagements"].toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Celebrity Message
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["celebrityMessage"].toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>



                    {/* <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Due Date
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["expiryDate"].toDate().getDate().toString()}-{(reqData["expiryDate"].toDate().getMonth() + 1).toString()}-{reqData["expiryDate"].toDate().getFullYear().toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr> */}



                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Status
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                <div className="text-md bg-red-500 pl-3 pr-3 pt-1 pb-1 rounded-3xl">
                                    {reqData["status"]}
                                </div>
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Review
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["reviewed"] == true ? reqData["review"]["remarks"] : "-"}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                </tbody>
            </Table>


        </div>
    )

}